import AirTracker, { Config, Environment } from '@airwallex/airtracker';
import * as versionFile from '../version.json';
import { getPageEnvByHost } from './environment';

const config: Config = {
  appName: 'pa_getpaid_checkout',
  appVersion: versionFile.version,
  env: getPageEnvByHost() as Environment,
  interceptNetworkTraffic: false,
  enableErrorMonitoring: true,
  enablePerformanceLog: true,
  enableAssetSpeedMonitoring: true,
};

export const airTracker = new AirTracker({ config });
